import React, { useState, useEffect, useRef, useLayoutEffect } from "react"
import { Input } from "@stardust-ds/react"

import styles from "./index.module.scss"
import useClickOutside from "../../../hooks/useClickOutside"
import CloseIcon from "../../../assets/icons/CloseIcon"
import DownArrow from "../../../assets/icons/DownArrow"
import SearchIcon from "../../../assets/icons/SearchIcon"
import { isMobile } from "react-device-detect"

const SearchTabs = (props) => {
  const { tabs, selectTab, openSearch, onRequestClose } = props

  const [search, setSearch] = useState("")

  const handleSelectTab = (tab) => {
    selectTab(tab)
    setSearch("")
    onRequestClose()
  }

  if (!tabs?.length || !openSearch) return null

  const filteredTabs = tabs.filter(
    (t) => t?.label?.toLowerCase()?.indexOf(search?.toLowerCase()) !== -1,
  )

  const handleSetSearch = (e) => {
    setSearch(e?.target?.value)
  }

  const handleRequestClose = (e) => {
    e.stopPropagation()
    setSearch("")
    onRequestClose()
  }

  return (
    <div className={styles.searchTabsContainer}>
      <div>
        <Input
          placeholder="Pesquisar guias..."
          iconLeft={
            <div>
              <SearchIcon fill="#ACB4BA" />
            </div>
          }
          iconRight={
            <div onClick={handleRequestClose} className={styles.closeSearchList}>
              <CloseIcon fill="#ACB4BA" />
            </div>
          }
          bColor="transparent"
          className={styles.searchInput}
          onChange={handleSetSearch}
        />
      </div>
      <div className={styles.searchTabsOptions}>
        {filteredTabs.map((t, i) => (
          <p
            key={i}
            className={styles.searchTab}
            onClick={(e) => {
              e.stopPropagation()
              handleSelectTab(t)
            }}
          >
            {t.label}
          </p>
        ))}
      </div>
    </div>
  )
}

const HideTabs = (props) => {
  const { hideTabs, onSelectTab, ...rest } = props

  const [openSearch, setOpenSearch] = useState(false)

  const onRequestOpen = () => {
    setOpenSearch(true)
  }

  const onRequestClose = () => {
    setOpenSearch(false)
  }

  const searchTabsContainerRef = useRef(null)
  useClickOutside(searchTabsContainerRef, onRequestClose)

  if (!hideTabs?.length) return null

  return (
    <li
      ref={searchTabsContainerRef}
      className={`${styles.tab} ${styles.groupTabs}`}
      onClick={onRequestOpen}
      {...rest}
    >
      <div style={{ display: "flex" }}>
        ...
        <DownArrow className={`${openSearch ? styles.rotateIcon : ""}`} />
      </div>
      <SearchTabs
        tabs={hideTabs}
        selectTab={onSelectTab}
        openSearch={openSearch}
        onRequestClose={onRequestClose}
      />
    </li>
  )
}

export const Tab = React.forwardRef((props, ref) => {
  const { tab, selectedTab, onSelectTab, onCloseTab, disableCloseTab, ...oRest } = props

  if (!tab) return null

  const handleOnSelectTab = () => {
    onSelectTab?.(tab)
  }

  const handleOnCloseTab = (e) => {
    e.stopPropagation()
    onCloseTab?.(tab)
  }

  const selectedTabClass = selectedTab?.value === tab?.value ? styles.selectedTab : ""

  const classes = `${selectedTabClass} ${styles.tab} ${styles.tabEllipsis}`

  const bOnClose = typeof onCloseTab === "function"

  return (
    <li ref={ref} className={classes} onClick={handleOnSelectTab} {...oRest}>
      {tab.label}
      {bOnClose && (
        <CloseIcon
          onClick={handleOnCloseTab}
          display={disableCloseTab ? "none" : "inherit"}
        />
      )}
    </li>
  )
})

const SelectTabs = React.forwardRef((props, ref) => {
  const {
    tabs,
    oSelectTab,
    onSelectTab,
    onCloseTab,
    onChangeOrderTabs,
    disableCloseTab,
  } = props

  const [showTabs, setShowTabs] = useState([])
  const [allTabs, setAllTabs] = useState([])
  const [selected, setSelected] = useState(oSelectTab || null)

  const tabListRef = useRef(null)

  const hiddenTabs = allTabs?.filter(
    (t) => !showTabs?.some((st) => st?.value === t?.value),
  )

  useEffect(() => {
    if (oSelectTab) setSelected(oSelectTab)
  }, [oSelectTab])

  useEffect(() => {
    setAllTabs(tabs)
    setShowTabs(tabs)
    // if (!selected) setSelected(tabs[0] || null);
  }, [tabs])

  const closeTab = (tab, hideTab = false) => {
    const auxTabs = showTabs?.filter((t, i) => {
      if (selected?.value === tab?.value && t?.value === selected?.value) {
        const newSelected =
          i + 1 === showTabs.length ? showTabs[showTabs.length - 2] : showTabs[i]
        setSelected(newSelected)
      }

      if (t?.value !== tab?.value) return t
    })
    setShowTabs(auxTabs)
    const lastTab = allTabs?.length === 1
    if (!hideTab) onCloseTab?.(tab, lastTab)
  }

  const selectTab = (tab) => {
    setSelected(tab)
    const hasShowed = showTabs?.find((t) => t?.value === tab?.value)
    if (!hasShowed) {
      onSelectTab?.(tab, true)
      const newShowTabs = [tab, ...showTabs]
      const rest = allTabs?.filter(
        (t) => !newShowTabs?.some((st) => st?.value === t?.value),
      )

      setShowTabs(newShowTabs)
      setAllTabs([...newShowTabs, ...rest])
      onChangeOrderTabs?.([...newShowTabs, ...rest])
      return
    }

    onSelectTab?.(tab, false)
  }

  const totalTabsWidth = () => {
    if (!tabListRef?.current?.children) return
    let tabsWidth = 0
    const tabsLength = Array.from(tabListRef.current.children)?.length

    for (let i = 0; i < tabsLength; i++) {
      const width = tabListRef.current.children[i]?.offsetWidth

      if (width > 0) tabsWidth += width + 24
      if (i + 1 === tabsLength) return tabsWidth - 24
    }
  }
  const hideTabs = (resizeDirection = "right") => {
    if (!tabListRef?.current?.children) return
    const totalWidth = totalTabsWidth()
    const containerMaxWidth =
      document?.body?.offsetWidth > 0 && !isMobile
        ? Number(document?.body?.offsetWidth - 96 - 105 - 110)
        : document?.body?.offsetWidth > 0 && isMobile
        ? Number(document?.body?.offsetWidth)
        : null
    if (containerMaxWidth <= 0) return
    if (totalWidth > containerMaxWidth && resizeDirection === "right") {
      closeTab(showTabs[showTabs?.length - 1], true)
      return
    }
    if (!hiddenTabs?.length) return
    if (containerMaxWidth >= totalWidth + 174 && resizeDirection === "left") {
      setShowTabs([...showTabs, hiddenTabs[0]])
    }
  }

  useLayoutEffect(() => {
    if (tabListRef.current == null) return
    hideTabs()
  }, [showTabs])

  useEffect(() => {
    let time
    let previousResize = window.innerWidth
    window.addEventListener("resize", () => {
      clearTimeout(time)
      time = setTimeout(() => {
        const resizeDirection = window.innerWidth >= previousResize ? "left" : "right"
        hideTabs(resizeDirection)
        previousResize = window.innerWidth
      }, 200)
    })

    return () => window.removeEventListener("resize", hideTabs)
  })

  if (!tabs?.length) return null

  return (
    <div ref={ref} className={styles.tabListContainer}>
      <ul ref={tabListRef} className={styles.tabList}>
        {showTabs.map((tab, i) => (
          <Tab
            key={i}
            tab={tab}
            selectedTab={selected}
            onSelectTab={selectTab}
            onCloseTab={closeTab}
            disableCloseTab={disableCloseTab}
          />
        ))}
        <HideTabs hideTabs={hiddenTabs} onSelectTab={selectTab} />
      </ul>
    </div>
  )
})

SelectTabs.displayName = "SelectTabs"

export default SelectTabs
